import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { nextTick as t } from "./nextTick.js";
import { a as e } from "../chunks/mat3f64.js";
import { a as s } from "../chunks/mat4f64.js";
import { c as r } from "../chunks/quatf64.js";
import { c as i } from "../chunks/vec2f64.js";
import { b as f } from "../chunks/vec3f64.js";
import { a as h } from "../chunks/vec4f64.js";

var m = /*#__PURE__*/function () {
  function m(t, e, s) {
    _classCallCheck(this, m);

    this.itemByteSize = t, this.itemCreate = e, this._buffers = new Array(), this._items = new Array(), this._itemsPtr = 0, this._itemsPerBuffer = Math.ceil(s / this.itemByteSize);
  }

  _createClass(m, [{
    key: "get",
    value: function get() {
      var _this = this;

      0 === this._itemsPtr && t(function () {
        return _this.reset();
      });
      var e = Math.floor(this._itemsPtr / this._itemsPerBuffer);

      for (; this._buffers.length <= e;) {
        var _t = new ArrayBuffer(this._itemsPerBuffer * this.itemByteSize);

        for (var _e = 0; _e < this._itemsPerBuffer; ++_e) {
          this._items.push(this.itemCreate(_t, _e * this.itemByteSize));
        }

        this._buffers.push(_t);
      }

      return this._items[this._itemsPtr++];
    }
  }, {
    key: "reset",
    value: function reset() {
      var t = 2 * (Math.floor(this._itemsPtr / this._itemsPerBuffer) + 1);

      for (; this._buffers.length > t;) {
        this._buffers.pop(), this._items.length = this._buffers.length * this._itemsPerBuffer;
      }

      this._itemsPtr = 0;
    }
  }, {
    key: "test",
    get: function get() {
      return {
        size: this._buffers.length * this._itemsPerBuffer * this.itemByteSize
      };
    }
  }], [{
    key: "createVec2f64",
    value: function createVec2f64() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : a;
      return new m(16, i, t);
    }
  }, {
    key: "createVec3f64",
    value: function createVec3f64() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : a;
      return new m(24, f, t);
    }
  }, {
    key: "createVec4f64",
    value: function createVec4f64() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : a;
      return new m(32, h, t);
    }
  }, {
    key: "createMat3f64",
    value: function createMat3f64() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : a;
      return new m(72, e, t);
    }
  }, {
    key: "createMat4f64",
    value: function createMat4f64() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : a;
      return new m(128, s, t);
    }
  }, {
    key: "createQuatf64",
    value: function createQuatf64() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : a;
      return new m(32, r, t);
    }
  }]);

  return m;
}();

var a = 4096;
export { m as VectorStack };